import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NavigationDataGuard } from './guards/navigation-data-guard';
import { AssetsDataResolver } from './shared/resolvers/assets-data.resolver';
import { DefaultRedirectGuard } from './guards/default-redirect-guard';
import { ForecastProviderGuard } from './guards/forecastProvider.guard';
import { RevenuesV2Guard } from './guards/revenuesV2.guard';
import { RevenuesV1Guard } from './guards/revenuesV1.guard';


@Component({
    template: '',
    standalone: false
})
export class LoadingComponent {}

export const routes: Routes = [
  {
    path: '',
    component: LoadingComponent,
    resolve: {navigationDataGuard: NavigationDataGuard},
    pathMatch: 'full'
  },
  {
    path: 'monitor',
    loadChildren: () => import('./monitor/monitor.module').then(m => m.MonitorModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_monitor_windlog'
    }
  },
  {
    path: 'analyze',
    loadChildren: () => import('./analyze/analyze.module').then(m => m.AnalyzeModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard, data: AssetsDataResolver},
    data: {
      role: 'module_analyze_windlog'
    }
  },
  {
    path: 'kpi-follow-up',
    loadChildren: () => import('./kpi-follow-up/kpi-follow-up.module').then(m => m.KpiFollowUpModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_kpifollowup_windlog'
    }
  },
  {
    path: 'overview',
    loadChildren: () => import('./overview-board/overview-board.module').then(m => m.OverviewBoardModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_overview_windlog'
    }
  },
  {
    path: 'budget',
    loadChildren: () => import('./budget-follow-up/budget-follow-up.module').then(m => m.BudgetFollowUpModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_budget_windlog'
    }
  },
  {
    path: 'planning',
    loadChildren: () => import('./planning/planning.module').then(m => m.PlanningModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_planning_windlog'
    }
  },
  {
    path: 'forecast',
    loadChildren: () => import('./forecast/forecast.module').then(m => m.ForecastModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_forecast_windlog'
    }
  },
  {
    path: 'troubleshoot',
    loadChildren: () => import('./troubleshoot/troubleshoot.module').then(m => m.TroubleshootModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_troubleshoot_windlog'
    }
  },
  {
    path: 'reporting',
    loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard, data: AssetsDataResolver},
    data: {
      role: 'module_reporting_windlog'
    }
  },
  {
    path: 'data_studio',
    loadChildren: () => import('./data-studio-redesign/data-studio-redesign.module').then(m => m.DataStudioRedesignModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard, data: AssetsDataResolver},
    data: {
      role: 'module_datastudio_windlog'
    }
  },
  {
    path: 'settings',
    loadChildren: () => import('./user-preferences/user-preferences.module').then(m => m.UserPreferencesModule),
    resolve: {navigationDataGuard: NavigationDataGuard},

  },
  {
    path: 'check_revenues',
    loadChildren: () => import('./check-revenues/check-revenues.module').then(m => m.CheckRevenuesModule),
    canActivate: [AuthGuard, RevenuesV1Guard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_checkrevenues_windlog'
    }
  },
  {
    path: 'revenues',
    loadChildren: () => import('./revenues/revenues.module').then(m => m.RevenuesModule),
    canActivate: [AuthGuard, RevenuesV2Guard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_checkrevenues_windlog'
    }
  },
  {
    path: 'de_ice',
    loadChildren: () => import('./de-ice/de-ice.module').then(m => m.DeIceModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_deice_windlog'
    }
  },
  {
    path: 'logbook',
    loadChildren: () => import('./tclasses/tclasses.module').then(m => m.TclassesModule),
    canActivate: [AuthGuard,ForecastProviderGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_logbook_windlog'
    }
  },
  {
    path: 'pexapark',
    loadChildren: () => import('./pexapark/pexapark.module').then(m => m.PexaparkModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
        role: 'module_pexapark_windlog'
    }
  },
  {
    path: 'check-ppa',
    loadChildren: () => import('./check-ppa/check-ppa.module').then(m => m.CheckPPAModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},

    data: {
        role: 'module_checkppa_windlog'
    }
  },
  {
    path: 'predictive',
    loadChildren: () => import('./predictive/predictive.module').then(m => m.PredictiveModule),
    canActivate: [AuthGuard],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_predictive_windlog'
    }
  },
  {
    path: 'performance-analytics',
    loadChildren: () => import('./performance-analytics/performance-analytics.module').then(m => m.PerformanceAnalyticsModule),
    canActivate: [ AuthGuard ],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_performanceanalytics_windlog'
    }
  },
  {
    path: 'tickets',
    loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsModule),
    canActivate: [ AuthGuard ],
    resolve: {navigationDataGuard: NavigationDataGuard},
    data: {
      role: 'module_tickets_windlog'
    }
  },
  {
    path: '**',
    component: LoadingComponent,
    canActivate: [ DefaultRedirectGuard ],
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
